import CartSumBlock from './CartSumBlock'

export default CartSumBlock
